// SCREENINGS Store
import store from ".."

const state = {
  STATUS: null,
  API_ROUTE: "/drusa",
  doctorsList: []
}

const getters = {
  doctorsList: state => {
    //return state.doctorsList
    //return state.doctorsList = state.doctorsList.filter(dr => dr.Practice.indexOf('Center') > -1)
    return (state.doctorsList = state.doctorsList.filter(dr => dr.State.indexOf("FL") > -1))
    //return state.doctorsList = state.doctorsList.filter(dr => dr.Practice != "")
    //return state.doctorsList = state.doctorsList.filter(dr => dr.Qualification != "")
  }
}

// Called from Action to change State
const mutations = {}

// Called externally to commit a State Mutation
const actions = {
  listDoctors({ commit }, payload) {
    const url = process.env.VUE_APP_URL + state.API_ROUTE
    const config = {
      headers: {
        "Content-Type": "application/json"
        //'Access-Control-Allow-Origin': '*',
      }
    }
    const data = null
    window.axios
      .get(url, data, config)
      .then(r => r.data) //.slice(1, 200)
      .then(doctors => {
        state.doctorsList = doctors
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
